module.exports = __webpack_public_path__ + "img/esc_4_act_2.bbb606d5.png";